import React, { useEffect, useState, useCallback, forwardRef, useImperativeHandle, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Backdrop from '@material-ui/core/Backdrop';
import Checkbox from '@material-ui/core/Checkbox';
import { CircularProgress, Button, Divider } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isUndefined, isNull } from 'lodash';
import { format } from "date-fns";
import { deepOrange, red } from '@material-ui/core/colors';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import FormControl from '@material-ui/core/FormControl';
/**Connections */
import { uploadContentService } from '../../../services';

import { toast } from 'react-toastify';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: '#252525',
    color: red[50],

  },
  rotateLoader: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  },
  buttonMarkAll: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    width: 150,
    borderRadius: 0,
  },
  avatar1: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    maxWidth: '40px', maxHeight: '50px', minWidth: '30px', minHeight: '30px',
  },
  buttonProgress: {
    color: deepOrange[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

}));

const OrangeCheckbox = withStyles({
  root: {
    color: deepOrange[400],
    '&$checked': {
      color: deepOrange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

function CheckBoxLists({ playlists, modalState }, ref) {
  const classes = useStyles();
  const [checked, setChecked] = useState([]);
  const [dynamicPlaylistsDetail, setDynamicPlaylistsDetail] = useState([]);
  const [btnMarkAll, setBtnMarkAll] = useState('');
  const { user } = useSelector(state => state.userAuthentication);
  const [idDetail, setIdDetail] = useState([]);
  const [searchValue, setSearchValue] = useState()
  const [contentDetail, setContentDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const timer = useRef();
  const [allCheckboxData, setAllCheckBoxData] = useState([]);
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = React.useState(false);


  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      border: '1px solid #ced4da',
      fontSize: 16,
      width: 300,
      padding: '10px 12px',
      marginLeft: theme.spacing(.3),
      transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
  }))(InputBase);




  //Forced to use class component due to this method won't work if not class component...
  useImperativeHandle(ref, () => ({
    setFromOutside(startDate, endDate) {
      if (!isUndefined(startDate) && !isNull(startDate)
        && !isUndefined(endDate) && !isNull(endDate)) {
        updateDateSchedule(startDate, endDate)

      }
      else {
        alert("No date inputted");
      }
    }
  }), [])

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const loaderOnClick = (e) => {

    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }

  }

  const getDynamicPlaylistsDetails = useCallback(async (id) => {
    if (!isUndefined(user)) {

      const res = await uploadContentService.dynamicContentPlaylistDetail(user, id);
      if (!isUndefined(res)) {

        dynamicPlaylistsDetail.push(res);
        contentDetail.push(res['content']);
        idDetail.push(res['id'])
      }
      console.log(contentDetail);
    }
  }, [user]);
  //Update Date of each selected box
  const updateDateSchedule = useCallback(async (startValidityDate, endValidtiyDate) => {

    let newIdArray = [...idDetail];
    let newContentArray = [...contentDetail];
    let startDateValueFormatted = format(startValidityDate, "yyyy-MM-dd'T'hh:mm:00'");
    let validityEndDateFormatted = format(endValidtiyDate, "yyyy-MM-dd'T'hh:mm:00'");

    for (let i = 0; i < newContentArray.length; i++) {
      for (let j = 0; j < newContentArray[i].length; j++) {
        newContentArray[i][j] = {
          ...newContentArray[i][j], validityStartDate: startDateValueFormatted,
          validityEndDate: validityEndDateFormatted,
        }
        newContentArray[i][j].ContentId = newContentArray[i][j]['contentId'];
        newContentArray[i][j].FileName = newContentArray[i][j]['fileName'];
        newContentArray[i][j].displayDuration = newContentArray[i][j]['displayDuration'];
        newContentArray[i][j].ValidityStartDate = newContentArray[i][j]['validityEndDate'];
        newContentArray[i][j].ValidityEndDate = newContentArray[i][j]['validityStartDate'];
        delete newContentArray[i][j].contentId;
        delete newContentArray[i][j].fileName;
        delete newContentArray[i][j].validityEndDate;
        delete newContentArray[i][j].validityStartDate;
      }
    }
    var i = 0;
    console.log(i);
    for (var i = 0; i < newIdArray.length; i++) {
      if (!isUndefined(user) && ((!isUndefined(newContentArray)))) {
        if ((newContentArray[i] === 0)) {
          i++;
        }
        else {
          loaderOnClick()
          setOpen(!open);
          const res = await uploadContentService.updateSchedule(user, newContentArray[i], newIdArray[i]);
          if (i + 1 === newIdArray.length) {
            toast.success('Successfully Updated Playlist.', { autoClose: 4000 });
            console.log(res);
            modalState(false);
          }
        }
      }
      setOpen(false);
      setSuccess(true);
      setLoading(false);
    }
  }, [user]);

  function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
  }
  //solo select box is clicked, or individually clicked
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      getDynamicPlaylistsDetails(value.id);
      newChecked.push(value);
    }
    else {
      newChecked.splice(currentIndex, 1);
      contentDetail.splice(currentIndex, 1);
      idDetail.splice(currentIndex, 1);
    }
    setChecked(newChecked);

  };
  //Select all selectbox and save in a state
  const handleToggleAll = (items) => () => {
    getAllData(items)
    setChecked((checked, items));

    for (var i = 0; i < items.length; i++) {
      getDynamicPlaylistsDetails(items[i].id);
    }

  };
  //Unmark all select box, erase all selected data in state
  const handleUnToggleAll = (items) => () => {
    setAllCheckBoxData([]);
    setChecked(not(checked, items));
    setIdDetail([]);
    setContentDetail([]);
  };
  //If mark all button is clicked, store all data to state
  const getAllData = (itmes) => {
    setAllCheckBoxData(
      itmes.map(d => {
        return {
          content: d.content,
          creationDate: d.creationDate,
          fileHash: d.fileHash,
          fileSize: d.fileSize,
          id: d.id,
          name: d.name,
          permissions: d.permissions,
          physicalPath: d.physicalPath,
          presentations: d.presentations,
          supportsAudio: d.supportsAudio,
          supportsImages: d.supportsImages,
          supportsVideo: d.supportsVideo,
        };
      })
    );

  }

  useEffect(() => {

  }, [user]);

  return (
    <div>
      <div className="card-content">
        Spillelister
      </div>
      <Divider />
      <Button aria-label="delete" className={classes.avatar1}>
        <SearchIcon />
      </Button>
      <FormControl className={classes.margin}>
        <BootstrapInput placeholder="Search here" id="bootstrap-input"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)} />
      </FormControl>
      <Divider />
      <Divider />
      <Button className={classes.buttonMarkAll}
        onClick={handleToggleAll(playlists)} variant="contained" color="primary">Mark All</Button>
      <Button className={classes.buttonMarkAll} onClick={handleUnToggleAll(playlists)} variant="contained" color="primary">Unmark All</Button>
      <List className={classes.root} >
        {!isUndefined(playlists) ? (
          playlists.filter(value => {
            if (!searchValue) return true;
            if (value.name.includes(searchValue)) {
              return true;
            }
            return false;
          }).map((value) => {
            const labelId = `checkbox-list-label-${value}`;
            return (
              <ListItem key={value.id} role={undefined}
                dense
                button
                onClick={handleToggle(value)}>
                <ListItemIcon >
                  <OrangeCheckbox
                    edge="start"
                    checked={checked.indexOf(value) !== -1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText className={classes.colorChange} id={labelId}> {value.name}
                  <pre></pre>
                </ListItemText>
              </ListItem>
            );
          })
        ) : (
          <div className={classes.rotateLoader}>
            <CircularProgress variant="determinate" value={progress} />
          </div>
        )}
      </List>
      <Backdrop className={classes.backdrop} open={open} >
      </Backdrop>
      {loading && <CircularProgress size={124} className={classes.buttonProgress} />}
    </div>
  );
}

export default forwardRef(CheckBoxLists)